<div class="rejected-by-offer">
  <ng-container *ngIf="!isLoading">
    <img src="assets/icons/info-filled.svg" alt="Icono Rechazado" />
    <h4>La compra supera el límite de financiación</h4>
    <p>
      En este momento Powerpay te permite pagar <strong>hasta S/ 2,800</strong> en cuotas flexibles.
      Te invitamos a volver al comercio y ajustar el monto de la compra para aprovechar al máximo el
      poder de Powerpay.
    </p>
    <div>
      <button class="btn-primary-bg" (click)="onKillPurchase()">Volver al comercio</button>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div class="rejected-by-offer">
      <layout-skeleton [data]="skeletonInfo[0]"></layout-skeleton>
      <layout-skeleton [data]="skeletonInfo[1]"></layout-skeleton>
      <layout-skeleton [data]="skeletonInfo[0]"></layout-skeleton>
    </div>
  </ng-container>
</div>
